module.exports = __webpack_public_path__ + "static/img/qyjr42.7755ab9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qyjr42.png
// module id = HDz+
// module chunks = 73